import * as Yup from "yup";

const validateSchema = function (schema, values) {
    try {
        schema.validateSync(values, {abortEarly: false});
        return {}
    } catch (error) {
        return getErrorsFromValidationError(error)
    }
}

const validateField = function (yupRule, fieldValue) {
    let schema = Yup.object().shape({
        singleValue: yupRule
    });
    let values = {singleValue: fieldValue};
    return validateSchema(schema, values).singleValue || "";
}

const validateObject = function (yupRulesJsonObject, valuesJsonObject) {
    let schema = Yup.object().shape(yupRulesJsonObject);
    return validateSchema(schema, valuesJsonObject);
}

const getErrorsFromValidationError = (validationError) => {
    const FIRST_ERROR = 0;
    return validationError.inner.reduce((errors, error) => {
        return {
            ...errors,
            [error.path]: error.errors[FIRST_ERROR],
        }
    }, {})
};

const ValidationHelperV2 = {
    validateField,
    validateObject
};
export default ValidationHelperV2;
